// A blank valuation request for a single estimator type. The estimator form is
// always built from these defaults and is never persisted (FCI-91/FCI-92).
// Exported so the calculator component shares the same defaults.
export function defaultValuationRequest(type = "") {
    return {
        type: type,
        converted_valuation_currency: "",
        date_range: "year",
        clarity: "",
        carat: "",
        color: "",
        cut: "",
        jurisdiction: "",
        fluorescence: "",
        symmetry: "",
        shape: "",
        polish: "",
    };
}

let state = {
    error: {},
    locations: {},
    user: {
        userType: String,
        userId: Number,
        merchantId: Number | Boolean,
        customerId: Number | Boolean,
        userName: String,
        userCurrency: "USD",
        userTimezone: "UTC",
    },
    jewelOptions: {},
    valuationIndexOptions: {},
    valuationIndexResult: {
        valuation: Object,
        valuationParameters: Object,
        timeSeriesData: Object,
    },
    valuationEstimateResult: {
        base_valuation: Number,
        parameters: Object,
    },
    valuationIndexTables: [],
};
export default state;
